// @flow
import React, {PureComponent} from 'react'
import I18n from 'I18n'
import {Link} from 'react-router-dom'
import ReactTable from 'react-table'
import styles from './AdminAMList.module.scss'
import 'react-table/react-table.css'
import {adminURL} from 'modules/Common/constants'

import PenIcon from '../svgIcons/pen.svg'
import AddAMModal from './AddAMModal'
import {formatTimestampToDate} from 'modules/Common/utils'

import type {StateProps, DispatchProps, OwnProps} from '../../containers/AdminAMListContainer'

export type Props = DispatchProps & StateProps & OwnProps;

export type State = {
  isShowAddModal: boolean
};

const I18nLocal = I18n.admin

export class AdminAMList extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isShowAddModal: false
    }
  }

  handleOpenAddModal = () => {
    this.setState({
      isShowAddModal: true
    })
  }
  handleCloseAddModal = () => {
    this.setState({
      isShowAddModal: false
    })
  }
  fetchData = (state: any, instance: any) => {
    this.props.getAccountManagers(state.page + 1, undefined, this.props.companyId || undefined).then(() => {
      const companyIds = []
      this.props.accountManagers.ids.map(key => {
        const item = this.props.accountManagers.records[key]
        if (!companyIds.includes(item.companyId) && item.companyId !== '') {
          companyIds.push(item.companyId)
        }
        return null
      })
      this.props.getCompanies(1, companyIds)
    })
  }
  calculateData = () => {
    return this.props.accountManagers.ids.map(key => {
      const item = this.props.accountManagers.records[key]
      const company = this.props.companies.records[item.companyId]
      return {
        id: item.id,
        name: item.name,
        email: item.persona.email,
        phoneNumber: item.persona.mobilePhoneNumber,
        clients: item.clientCount,
        userType: 'Head Account Manager',
        company: company ? company.fullName : '',
        companyId: item.companyId,
        lastLoggedIn: formatTimestampToDate(item.lastUpdateTimestamp, 'HH:mm DD/MM/YYYY')
      }
    })
  }

  render() {
    const data = this.calculateData()

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={this.props.isSubScreen ? styles.small : ''}>{I18nLocal.accountManagers}</span>
          <div onClick={this.handleOpenAddModal} className={styles.button}>
            {I18nLocal.addAccountManager}
          </div>
        </div>
        <div className={styles.table}>
          <ReactTable
            showPageSizeOptions={false}
            sortable={false}
            data={data}
            columns={[
              {
                id: 'index',
                Header: '#',
                Cell: props => {
                  return props.index + 1
                }
              },
              {
                id: 'name',
                Header: I18nLocal.name,
                accessor: 'name'
              },
              {
                Header: I18nLocal.email,
                Cell: props => {
                  return (
                    <Link className={styles['link']} to={adminURL.accountManagers.edit.replace(':id', props.original.id)}>
                      {props.original.email}
                    </Link>
                  )
                }
              },
              {
                Header: I18nLocal.phoneNumber,
                accessor: 'phoneNumber'
              },
              {
                Header: I18nLocal.clients,
                accessor: 'clients'
              },
              {
                Header: I18nLocal.userType,
                accessor: 'userType'
              },
              {
                Header: I18nLocal.company,

                Cell: props => {
                  return (
                    <Link className={styles['link']} to={adminURL.companies.detail.replace(':id', props.original.companyId)}>
                      {props.original.company}
                    </Link>
                  )
                }
              },

              {
                Header: '',
                Cell: props => {
                  return (
                    <Link className={styles['edit-button']} to={adminURL.accountManagers.edit.replace(':id', props.original.id)}>
                      <PenIcon width={15} height={15} />
                    </Link>
                  )
                }
              }
            ]}
            manual
            pages={this.props.accountManagers.numberOfPages}
            loading={this.props.isLoadingAccountManagers}
            onFetchData={this.fetchData}
          />
        </div>
        <AddAMModal
          handleClickButton={this.props.addOrUpdateAM}
          handleClose={this.handleCloseAddModal}
          isShow={this.state.isShowAddModal}
          error={this.props.error}
          companyId={this.props.companyId || undefined}
          companyName={this.props.companyName || undefined}
          isLoadingCompaniesSuggestion={this.props.isLoadingCompaniesSuggestion}
          companiesSuggestion={this.props.companiesSuggestion}
          getCompaniesSuggestion={this.props.getCompaniesSuggestion}
        />
      </div>
    )
  }
}

export default AdminAMList
